import { useState, useEffect } from "react";

export const useSearch = (open: boolean) => {
  const [searchTerm, setSearchTerm] = useState("");
  useEffect(() => {
    if (!open) {
      setSearchTerm("");
    }
  }, [open]);
  return { searchTerm, setSearchTerm };
};
